<app-nav-menu></app-nav-menu>
<div class="Main_page">

  <div class="row m-0 p-0">


    <div class="col-md-12 p-0">
      <div class="SearchPannel ">
        <div class="row m-0">

          <div class="heading_page">
            <span>Revenue Report</span>
          </div>
        </div>
        <div class="row m-0 mt-3">
          <div class="col-md-11 p-0">
            <div class="row m-0 mt-1">


              
              <div class="col-md-2 p-0  pl-1">

                <label>Agency Branch</label>
                <ng-select #agency_brancch [items]="agency_branchesList$ | async" placeholder="Agency_Branch"
              bindLabel="name" bindValue="code" class="multiselect"  [searchable]="true"
              [(ngModel)]="SelectReportObj.agencyId" id="agencybranch" [multiple]="false" >
            </ng-select>
              </div>
           
              <div class="col-md-2 p-0 pl-1">
                <label>Suppliers</label>
                <ng-select #supplier [items]="supplierList$ | async" placeholder="Suppliers" [multiple]="false"
                           class="revenuedropdown multiselect newvoidrevsp" bindLabel="name" bindValue="supplierId"
                           [searchable]="true" id="supplierd" [(ngModel)]="SelectReportObj.supplierId"
                           (change)="ChangeSupplier(SelectReportObj.supplierId)">
                </ng-select>
              </div>
              <div class="col-md-2 p-0 pl-1">
                <label>Office ID</label>
                <!--<input type="checkbox" [(ngModel)]="revenueObj.isOficeId" id="checkoffice" class="red-input"
                       style="margin-left: 20px;" /-->

                <ng-select #oficeId [items]="oficeIdList$ | async" placeholder="Office ID" [multiple]="false"
                           class="revenuedropdown multiselect newvoidofice" bindLabel="officeId" bindValue="officeId"
                           [searchable]="true" [(ngModel)]="SelectReportObj.officeId" for="ofc" id="abc">
                </ng-select>
              </div>
            </div>

          </div>
          <div class="col-md-1">

            <button (click)="LoadButtonClick()" class="LoadButton">
              Load
              <span class="load loading">
              </span>
            </button>

          </div>
        </div>


      </div>
    </div>


  </div>
  <br />
  <dx-data-grid #revenueGrid
  [dataSource]="revenueManagerList"
  [showBorders]="true"
  [showRowLines]="true"
  [columnAutoWidth]="true">
<dxo-scrolling mode="standard"></dxo-scrolling>
<dxo-paging [pageSize]="15"></dxo-paging>
<dxo-pager [showPageSizeSelector]="true"
 [allowedPageSizes]="[50, 100]"></dxo-pager>
<dxi-column [visible]="false" dataField="revenueId" alignment="center"></dxi-column>
<dxi-column caption="Revenue Type" dataField="requestType" alignment="center"></dxi-column>
<dxi-column [visible]="false" dataField="requestTypeID" alignment="center"></dxi-column>
<dxi-column dataField="name" alignment="center"></dxi-column>
<dxi-column dataField="type" alignment="center"></dxi-column>
<dxi-column dataField="appliesOn" alignment="center"></dxi-column>
<dxi-column dataField="agencyBranchList" width="120" alignment="center" dataType="string" caption="Agency/Branch"></dxi-column>

<dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate"></dxi-column>
<dxo-search-panel [visible]="true"></dxo-search-panel>

<div *dxTemplate="let data of 'actionCellTemplate'">
<a (click)="Edit_Click(data.data)"><i class="uil uil-edit action-class">Edit</i></a>
</div>
<div *dxTemplate="let data of 'cellTemplate'">
<div class="custom_margin">
<label class="switch">
<input type="checkbox" (change)="statusSave(data.data.status,data.data.revenueId)" [(ngModel)]="data.data.status">
<span></span>
</label>
</div>
</div>
</dx-data-grid>
  <div class="buttonNextdiv ">

    <button class="NextButton hiddenclass" id="buttonnext">
      Next
      <span class="next loadings">

      </span>
    </button>
  </div>
  <div id="errortext" class="hidemarginss">


    <span class="alert alert-danger" style=" position: relative; bottom: 40px;" id="Message_next"></span>
  </div>
</div>


